module.exports = __webpack_public_path__ + "assets/img/3.284a15d0.jpg";